export default __webpack_public_path__ + "static/media/perugbc3.7ff7d069.jpg";